export const QUARTER_PALLET_CDHP_LOGISTIC_MINIMUM_LOWER_RANGE = 2000;
export const QUARTER_PALLET_CDHP_LOGISTIC_MINIMUM_UPPER_RANGE = 4290;
export const EDHP_PALLET_LOGISTIC_MINIMUM = 561;
export const EURO_PALLET_LOGISTIC_MINIMUM = 561;
export const HALF_PALLET_NDHP_LOGISTIC_MINIMUM = 990;
